var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportteam2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 50 50",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34.9 24.2v-4c0-1.3-.2-2.3-.7-3.2-1.4-2.9-5-3.7-9.2-3.7s-7.8.9-9.2 3.8c-.4.9-.7 1.9-.7 3.2v4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 6,
    r: 4.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34.2 17c1.2-1.1 3.1-1.4 5.2-1.4 3.6 0 6.5 1 6.5 4.5v4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.4,
    cy: 9.7,
    r: 2.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.8 17c-1.2-1.1-3.1-1.4-5.2-1.4-3.6 0-6.5 1-6.5 4.5v4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6,
    cy: 9.7,
    r: 2.8
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8.3 29.2c.4 2.3 1.3 4.4 2.5 6.2l-3.2 4.4 3.7 3.8 4.3-3.2c1.8 1.2 3.9 2.1 6.1 2.6l.8 5.4h5.2l.8-5.4c2.2-.5 4.3-1.3 6.1-2.6l4.3 3.2 3.7-3.8-3.2-4.4c1.2-1.9 2.1-4 2.5-6.2l5.2-.8v-4.3h-44.1v4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 33.6c4.3 0 7.7-3.5 7.7-7.9 0-.6-.1-1.1-.2-1.6h-15c-.1.5-.2 1.1-.2 1.6 0 4.4 3.4 7.9 7.7 7.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportteam2);
export default __webpack_public_path__ + "static/media/support team (2).98d8c46341180ec7f899c454981b73c4.svg";
export { ForwardRef as ReactComponent };